import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, url: String }

  async copy(event) {
    event.preventDefault()
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch (_error) {
      window.prompt("Copy this power phrase", this.textValue)
    }
    if (!this.urlValue) return

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    if (!response.ok) return

    const html = await response.text()
    if (html && window.Turbo) window.Turbo.renderStreamMessage(html)
  }
}
